// extracted by mini-css-extract-plugin
export default {"container":"style_container__+WouF","textCenter":"style_textCenter__gRWnL","textDiv":"style_textDiv__7VrUX","startButton":"style_startButton__Kqman"};